import { AddressAttachedToType } from 'addresses/enums';
import { IStateAutocomplete } from 'addresses/types';
import { ContactGroupType } from 'contacts/enums';
import { ILocationForm } from 'contacts/types';

export const mapLocationForm = (data: ILocationForm, contactGroupType: ContactGroupType) => {
  const { state } = data;

  const customerFields = mapLocationFormCustomerFields(data, contactGroupType);

  return {
    address: {
      ...(data?.addressId ? { id: data.addressId } : {}),
      line1: data?.line1,
      line2: data?.line2,
      city: data?.city,
      country: data?.country?.abbreviation,
      name: data?.name,
      state: (state as IStateAutocomplete)?.id?.toString() || (state as string),
      zip: data?.zip,
      ...customerFields,
    },
    attachedTo: AddressAttachedToType.CONTACT_GROUP,
    contactGroup: data?.contactGroup?.id,
  };
};

const mapLocationFormCustomerFields = (data: ILocationForm, contactGroupType: ContactGroupType) => {
  if (contactGroupType !== ContactGroupType.CUSTOMER) {
    return {};
  }

  return {
    externalCustomerNumber: data?.customerNumber,
    ...(data?.isShipTo !== undefined && { isShipTo: data?.isShipTo ? 1 : 0 }),
    ...(data?.isBillTo !== undefined && { isBillTo: data?.isBillTo ? 1 : 0 }),
  };
};
